// extracted by mini-css-extract-plugin
export var legendIndicator = "_ca-1";
export var legendRight = "_ca-0";